exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Resource Link module should live here.\n * Import as neede like so:\n * ...\n * import resourceLinkStyles from 'resourceLinkModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"resource-link-item\">\n * ...\n */\n\n.modules-resourceLink-___resourceLinkModuleStyles__resource-link-item___2Kxno {\n\n}\n\n.modules-resourceLink-___resourceLinkModuleStyles__-resource-link-form___2T8qP {\n  \n}\n", ""]);

// exports
exports.locals = {
	"resource-link-item": "modules-resourceLink-___resourceLinkModuleStyles__resource-link-item___2Kxno",
	"-resource-link-form": "modules-resourceLink-___resourceLinkModuleStyles__-resource-link-form___2T8qP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/resourceLink/resourceLinkModuleStyles.css
// module id = 1354
// module chunks = 1